"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTAFooter = exports.tryGenerateOneLink = exports.tryGenerateOneLinkOrDefault = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const web_i18n_1 = require("@snapchat/web-i18n");
const link_1 = __importDefault(require("next/link"));
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const messageLoader_1 = require("../../i18n/messageLoader");
const CTAFooter_module_css_1 = __importDefault(require("./CTAFooter.module.css"));
const MobileCTAVariants_1 = require("./MobileCTAVariants");
const Footer_1 = require("./Footer");
const oneLinkUrlGenerator_1 = require("./oneLinkUrlGenerator");
const urlUtils_1 = require("../../utils/urlUtils");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const web_env_1 = require("@snapchat/web-env");
const web_graphene_reporting_1 = require("@snapchat/web-graphene-reporting");
const web_extraction_1 = require("@snapchat/web-extraction");
/**
 * Generates a one link if possible OR default to a fallback URL
 * Note:
 * - We will improve this function to build the fallback URL given a deeplink URL.
 * - For now, we want to know how often we use the fallback.
 */
function tryGenerateOneLinkOrDefault({ oneLinkParams, webClientId, webPageViewTraceId, config, fallbackUrl, pageType, }) {
    const oneLink = tryGenerateOneLink(oneLinkParams, webClientId, webPageViewTraceId, config);
    let paramsVariant = "no_params";
    if (oneLinkParams && webClientId) {
        paramsVariant = "with_one_link_params_and_wcid";
    }
    else if (oneLinkParams) {
        paramsVariant = "with_one_link_params";
    }
    else if (webClientId) {
        paramsVariant = "with_wcid";
    }
    try {
        if (typeof (0, web_env_1.getWindow)() !== "undefined") {
            const { browserName, os } = (0, web_extraction_1.extractUA)();
            void (0, web_graphene_reporting_1.incrementCounter)(`CTAFooter.try_generate_one_link_or_default.${web_blizzard_reporting_1.PageType[pageType].toString().toLowerCase()}`, 1, {
                browserName: browserName ?? "unknown",
                os: os ?? "unknown",
                usingFallback: String(Boolean(oneLink)),
                paramsVariant,
            });
        }
    }
    catch (e) {
        if (typeof (0, web_env_1.getWindow)() !== "undefined") {
            void (0, web_graphene_reporting_1.incrementCounter)(`CTAFooter.try_generate_one_link_or_default_failure`, 1, {
                pageType: web_blizzard_reporting_1.PageType[pageType].toString().toLowerCase(),
            });
        }
    }
    if (oneLink) {
        return oneLink;
    }
    return fallbackUrl;
}
exports.tryGenerateOneLinkOrDefault = tryGenerateOneLinkOrDefault;
/**
 * Generates a one link if possible
 * @param oneLinkParams parameters for the one link
 * @param webClientId web client id
 * @param webPageViewTraceId trace id
 */
function tryGenerateOneLink(oneLinkParams, webClientId, webPageViewTraceId, config) {
    /**
     *  We're seeing in-app browsers always use the fallback URL.
     *  Add some visibility to how we're generating deeplinks, and why they fail.
     */
    try {
        if (typeof (0, web_env_1.getWindow)() !== "undefined") {
            const { browserName, os } = (0, web_extraction_1.extractUA)();
            void (0, web_graphene_reporting_1.incrementCounter)(`CTAFooter.try_generate_one_link`, 1, {
                browserName: browserName ?? "unknown",
                os: os ?? "unknown",
                oneLinkParamsPresent: String(oneLinkParams !== undefined),
                wcidPresent: String(webClientId !== undefined),
            });
        }
    }
    catch (e) {
        // no op.
    }
    if (typeof (0, web_env_1.getWindow)() === "undefined" || !oneLinkParams || !webClientId) {
        return;
    }
    const onelinkGenerator = new oneLinkUrlGenerator_1.OneLinkUrlGenerator({
        oneLinkURL: oneLinkParams.oneLinkBaseUrl,
        // @ts-ignore: allow string value
        pidKeysList: oneLinkParams.pidKeys,
        // @ts-ignore: allow string value
        pidStaticValue: oneLinkParams.pidFallbackValue,
        // @ts-ignore: allow string value
        campaignKeysList: oneLinkParams.campaignKeys,
        // @ts-ignore: allow string value
        campaignStaticValue: oneLinkParams.campaignFallbackValue,
        gclIdParam: oneLinkParams.googleClickIdParam,
    });
    if (!config?.disableAfDp) {
        const urlWithWCID = (0, web_sc_cookies_1.addWebClientIdToURL)(oneLinkParams.deepLinkUrl, webClientId);
        const urlWithInviteID = (0, urlUtils_1.addInviteIdToURL)(urlWithWCID);
        onelinkGenerator.setCustomParameter("af_dp", "af_dp", 
        // @ts-ignore: allow string value
        encodeURIComponent(urlWithInviteID));
    }
    if (!config?.disableAfIosUrl) {
        onelinkGenerator.setCustomParameter("af_ios_url", "af_ios_url", 
        // @ts-ignore: allow string value
        encodeURIComponent(oneLinkParams.iosAppStoreUrl));
    }
    if (!config?.disableWebAfDp) {
        onelinkGenerator.setCustomParameter("af_web_dp", "af_web_dp", 
        // @ts-ignore: allow string value
        encodeURIComponent(oneLinkParams.desktopPageUrl));
    }
    if (webPageViewTraceId) {
        onelinkGenerator.setCustomParameter("trace_id", "trace_id", 
        // @ts-ignore: allow string value
        webPageViewTraceId);
    }
    return onelinkGenerator.generateUrl() || undefined;
}
exports.tryGenerateOneLink = tryGenerateOneLink;
function ParentMicrositeBanner() {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: CTAFooter_module_css_1.default.highlightedText, children: (0, jsx_runtime_1.jsx)(web_core_ui_1.ParentalBannerIcon, { size: "MEDIUM" }) }), (0, jsx_runtime_1.jsx)("span", { className: CTAFooter_module_css_1.default.text, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "wTgFeN", description: "Text on page footer, prompt to learn more about parents microsite.", defaultMessage: "Are you a parent? Learn what we're doing to help keep" }) })] }));
}
function ParentMicrositeCTA() {
    return ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "EMdw33", description: "Button text to redirect users to parents microsite page", defaultMessage: "Snapchatters safe." }));
}
// TODO: using this footer creates a warning about using matching divs, due to using the MediaQueries; we need to debug and fix
/**
 * A footer with a "Open your Snapchat" CTA on desktop, "Open in Snapchat" on mobile
 */
function CTAFooter(props) {
    const { locale, openInSnapchatLink, localeChange, useFixedDesktopFooter, oneLinkParams, webClientId, webPageViewTraceId, pageType, isMobile, showParentMicrositeBanner = false, } = props;
    const [messages, setMessages] = (0, react_1.useState)({});
    const [isMounted, setMounted] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setMounted(true);
        void (0, messageLoader_1.loadMessages)(locale).then((messages) => {
            setMessages(messages);
        });
    }, [locale]);
    const ctaUrl = tryGenerateOneLinkOrDefault({
        oneLinkParams,
        webClientId,
        webPageViewTraceId,
        fallbackUrl: openInSnapchatLink ?? "",
        pageType,
    });
    const defaultConfig = {
        actionName: web_blizzard_reporting_1.WebActionName.OpenWebChatCta,
        actionSource: web_blizzard_reporting_1.WebActionSource.TryNowLink,
        ctaLink: "https://web.snapchat.com/?ref=web_try_now_footer_cta",
        showIcon: true,
    };
    const micrositeConfig = {
        actionName: web_blizzard_reporting_1.WebActionName.ButtonClick,
        actionSource: web_blizzard_reporting_1.WebActionSource.OpenParentMicrositeCta,
        ctaLink: "https://parents.snapchat.com/?ref=web_snapchatters_safe_here_cta",
        showIcon: false,
    };
    const config = showParentMicrositeBanner ? micrositeConfig : defaultConfig;
    const handleOnClick = (0, react_1.useCallback)(() => {
        (0, web_blizzard_reporting_1.reportWebAction)({
            pageType,
            actionName: config.actionName,
            actionSource: config.actionSource,
            webClientId: webClientId ?? "",
        });
    }, [pageType, webClientId, config]);
    if (!isMounted) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: locale, defaultLocale: web_i18n_1.DEFAULT_LOCALE, messages: messages, children: isMobile ? ((0, jsx_runtime_1.jsx)(NewMobileCTA, { variant: props.mobileVariant, ctaProps: props })) : ((0, jsx_runtime_1.jsx)(Footer_1.Footer, { locale: locale, openInSnapChatLink: ctaUrl, localeChange: localeChange, useFixedDesktopFooter: useFixedDesktopFooter, pageType: pageType, isMobile: false, isContentsEmpty: !showParentMicrositeBanner, children: showParentMicrositeBanner && ((0, jsx_runtime_1.jsxs)("div", { className: CTAFooter_module_css_1.default.desktopContentWrapper, "data-testid": "cta-footer-microsite", children: [(0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H6", children: (0, jsx_runtime_1.jsx)(ParentMicrositeBanner, {}) }), (0, jsx_runtime_1.jsx)("div", { className: CTAFooter_module_css_1.default.desktopButtonWrapper, "data-testid": "", children: (0, jsx_runtime_1.jsx)(link_1.default, { href: config.ctaLink, passHref: true, children: (0, jsx_runtime_1.jsxs)("a", { className: CTAFooter_module_css_1.default.desktopCtaLink, target: "_blank", rel: "noopener", onClick: handleOnClick, children: [(0, jsx_runtime_1.jsx)(ParentMicrositeCTA, {}), config.showIcon && (0, jsx_runtime_1.jsx)(web_core_ui_1.DesktopIcon, { size: "MEDIUM" })] }) }) })] })) })) }));
}
exports.CTAFooter = CTAFooter;
function NewMobileCTA({ variant = MobileCTAVariants_1.MobileCTAVariants.BLACK_AND_YELLOW_DEFAULT, ctaProps, }) {
    const link = tryGenerateOneLinkOrDefault({
        oneLinkParams: ctaProps.oneLinkParams,
        webClientId: ctaProps.webClientId,
        webPageViewTraceId: ctaProps.webPageViewTraceId,
        fallbackUrl: "",
        pageType: ctaProps.pageType,
    });
    const mobileCtaProps = {
        downloadLink: ctaProps.downloadUrl,
        link,
        openInSnapchatLink: ctaProps.openInSnapchatLink,
        onClick: () => {
            const actionUrl = link || ctaProps.openInSnapchatLink;
            if (actionUrl) {
                const actionProps = {
                    pageType: ctaProps.pageType,
                    actionName: web_blizzard_reporting_1.WebActionName.OpenInSnapchatCta,
                    deepLinkUrl: actionUrl,
                    actionSource: web_blizzard_reporting_1.WebActionSource.CTAFooter,
                    webClientId: ctaProps.webClientId ?? "",
                };
                void (0, web_blizzard_reporting_1.reportWebAction)(actionProps);
            }
        },
    };
    const { Component: MobileCTAVariant, replaceFooter } = 
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    MobileCTAVariants_1.MobileCTAVariantsComponentsMap[variant] ||
        MobileCTAVariants_1.MobileCTAVariantsComponentsMap[MobileCTAVariants_1.MobileCTAVariants.BLACK_AND_YELLOW_DEFAULT];
    const ctaUrl = tryGenerateOneLinkOrDefault({
        oneLinkParams: ctaProps.oneLinkParams,
        webClientId: ctaProps.webClientId,
        webPageViewTraceId: ctaProps.webPageViewTraceId,
        fallbackUrl: ctaProps.openInSnapchatLink ?? "",
        pageType: ctaProps.pageType,
    });
    return replaceFooter ? ((0, jsx_runtime_1.jsx)("div", { className: CTAFooter_module_css_1.default.mobileCustomFooterWrapper, children: (0, jsx_runtime_1.jsx)(MobileCTAVariant, { ...mobileCtaProps }) })) : ((0, jsx_runtime_1.jsx)(Footer_1.Footer, { locale: ctaProps.locale, openInSnapChatLink: ctaUrl, localeChange: ctaProps.localeChange, useFixedDesktopFooter: ctaProps.useFixedDesktopFooter, pageType: ctaProps.pageType, isMobile: true, children: (0, jsx_runtime_1.jsx)(MobileCTAVariant, { ...mobileCtaProps }) }));
}
//# sourceMappingURL=CTAFooter.js.map